import { useCallback } from "react";
import { getTranslate } from "react-localize-redux";
import { useDispatch, useSelector } from "react-redux";

import { goToLink } from "@actions/common";
import { useGetTenantStatisticsQuery } from "@api";
import { showAlert as showAlertAction } from "@components/alert/action";
import { openGame } from "@pages/casino/utils";

const selectTranslate = (state) => ({
	translate: getTranslate(state.localize),
});

const useController = () => {
	const dispatch = useDispatch();
	const { translate } = useSelector(selectTranslate);

	const { data: lastWinners, isLoading } = useGetTenantStatisticsQuery();

	const redirect = useCallback(
		(...args) => {
			dispatch(goToLink(...args));
		},
		[goToLink]
	);

	const showAlert = useCallback(
		(...args) => {
			dispatch(showAlertAction(...args));
		},
		[showAlertAction]
	);

	const handleSliderItemClick = (win) => {
		openGame(win, redirect, showAlert);
	};

	return {
		helpers: { translate },
		state: {
			lastWinners: lastWinners?.latestCasinoWins || [],
			isLoading: isLoading,
		},
		handlers: { handleSliderItemClick },
	};
};

export default useController;
